// https://medium.com/@jwag/persisting-state-for-ag-grid-saving-column-order-filters-and-sort-options-e62f18332ebd

// get all the nodes from table
export const getNodes = (api, visible = false, filter = false) => {

    // api.getRenderedNodes are the nodes that are visible on the screen
    // if several pages, it does not work

    var nodes = [];

    if(visible){
        // visibles on the page
        nodes = api.getRenderedNodes();
    }
    else{
        if(!filter){
            api.forEachNode(node => {
                nodes.push(node);    
            });
        }
        else{
            api.forEachNodeAfterFilter(node => {
                nodes.push(node);    
            });

            //forEachNodeAfterFilterAndSort
        }
    }

    return nodes;
}

// get all the nodes data
export const getNodesData = (api, visible = false, filter = false) => {

    var data = [];
    const nodes = getNodes(api,visible,filter);

    nodes.forEach(node => {
        data.push(node?.data);    
    });

    return data;
}

// get menus where needs a selection if on any subitem
export const getNeedsSelection = (path,item) => {

    var depends = null;

    switch(item){

        case 'planifications': // parent
        case 'planification_reports':
        case 'planification_activities':
        case 'planification_restrictions':
        case 'planification_lps':
        case 'planification_holidays':
        case 'planification_unproductives':
        case 'planification_zones':        
        case 'planification_persons':
        case 'planification_providers':
        case 'plan_team':
            depends = 'planifications';
            break;
    }

    return depends;
}

// check the field to be filtered on backend with the selected option
export const getFieldSelection = (path,menu) => {

    /*
    // path can be table/view/N if editing directly on an item, so remove view/N
    path = replaceIfItemView(path);

    var split = path.split('/');
    var parentTable = split[1];
    var table = split.pop();
    
    var parentTable = getNeedsSelection(path,report);
    */

    // check parent menu if submenu depending on parent
    const fieldSelectionArray = {
        planifications: 'planification_id'
    };
    var parent = getNeedsSelection(path,menu);

    var field = null;

    switch(menu){

        // if workers on planification the field is 'planifications.id' because it is not a table with planification_id
        case 'plan_team':
            field = 'planifications.id';
            break;

        default:
            if(parent && fieldSelectionArray && Object.hasOwn(fieldSelectionArray,parent)){
                field = fieldSelectionArray[parent];
            }
            break;
    }

    return field;
}

// to manage parameters for the tables, separate by user id
export const getTableParam = (user,table,parameter) => {
    
    if(user?.id && table){

        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables,table) &&
            Object.hasOwn(tables[table],parameter) && 
            Object.hasOwn(tables[table][parameter],userId)
        ){
            return tables[table][parameter][userId];          
        }
    }
    
    return null;
}

export const setTableParam = (user,table,parameter,value) => {
    
    if(user?.id && table){

        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;

        if(!tables){
            tables = {};
        }

        if(!Object.hasOwn(tables,table)){
            tables[table] = {};
        }

        if(!Object.hasOwn(tables[table],parameter)){
            tables[table][parameter] = {};
        }

        tables[table][parameter][userId] = value;

        var json = JSON.stringify(tables);
        localStorage.setItem('tables',json);

        return value;
    }
    else{
        return null;
    }
}

export const removeTableParam = (user, table, parameter) => {

    if(user?.id && table){
    
        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;
        var value = null;
        
        if(
            tables && 
            Object.hasOwn(tables,table) &&
            Object.hasOwn(tables[table],parameter) && 
            Object.hasOwn(tables[table][parameter],userId)
        ){
            value = tables[table][parameter][userId];
            tables[table][parameter][userId] = null;
        }

        var json = JSON.stringify(tables);
        localStorage.setItem('tables',json);

        return value;
    }
    else{
        return null;
    }
}

// to build the fields for the selected item
export const buildSelectionInfo = (table,data,columns) => {

    var idField = 'id';
    var nameField = 'name';   
    
    //switch(table){
        
    //    case '':
    //        idField = '';
    //        nameField = '';
    //        break;
    //}

    var id = '';
    var name = '';
    if(data && Object.hasOwn(data,idField)){  
        id = data[idField];
    }

    if(data && Object.hasOwn(data,nameField)){  
        name = data[nameField];    
    }
      
    const itemInfo = {
        id: id,
        name: name
    };   

    switch(table){
        
        case 'planifications':
            // get plan info
            var plans = columns?.plan_id?.values;
            var plan = plans?.filter(item => item?.id === data['plan_id'])?.pop()?.name;                          
            
            if(plan && plan?.length > 0){
                if(itemInfo.name?.length > 0){
                    itemInfo.nameappend = ' ('+plan+')';
                }
                else{
                    itemInfo.nameappend = plan;
                }
            }
            break;
    }

    return itemInfo;
}

export const getTableConfig = (user,table,parameter = null) => {
    
    if(user?.id && table){

        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables,table) &&
            Object.hasOwn(tables[table],'config') && 
            Object.hasOwn(tables[table]['config'],userId)
        ){
        
            if(parameter){
                
                if(tables[table]['config'][userId] && Object.hasOwn(tables[table]['config'][userId],parameter)){
                    return tables[table]['config'][userId][parameter];
                }
            }
            else{
                return tables[table]['config'][userId];
            }
        }
    }
    
    return null;
}

// to check a table config, getting from backend or storage
export const checkTableConfig = (user, table, config, param) => {

    var value = getTableConfig(user,table,param);

    // if not saved, check config
    if(value === null){
        if(config && Object?.hasOwn(config,param)){
            value = config[param];
        }
    }

    return value;
}

export const setTableConfig = (api,user,table,parameter = null,value = null) => {
    
    if(user?.id && table){

        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;

        if(!tables){
            tables = {};   
        }

        if(!Object.hasOwn(tables,table)){
            tables[table] = {};
        }

        if(!Object.hasOwn(tables[table],'config')){
            tables[table]['config'] = {};
        }

        if(!Object.hasOwn(tables[table]['config'],userId) || !tables[table]['config'][userId]){
            tables[table]['config'][userId] = {};
        }

        var config = tables[table]['config'][userId];

        if(!parameter){
            config.columnState = api?.getColumnState();
            config.groupState = api?.getColumnGroupState();
            config.filterState = api?.getFilterModel();
        }
        else{

            switch(parameter){
                
                case 'columnState':                    
                    config[parameter] = api?.getColumnState();
                    break;

                case 'groupState':
                    config[parameter] = api?.getColumnGroupState();
                    break;

                case 'filterState':
                    config[parameter] = api?.getFilterModel();                
                    break;

                case 'state':
                    config[parameter] = api?.getState();                
                    break;

                default:
                    config[parameter] = value;
                    break;
            }
        }
		
        tables[table]['config'][userId] = config;

        var json = JSON.stringify(tables);
        localStorage.setItem('tables',json);

        return config;
    }
    else{
        return null;
    }
}

export const removeTableConfig = (user, table, parameter = null) => {

    if(user?.id && table){
    
        var tablesJson = localStorage.getItem('tables');
        var tables = JSON.parse(tablesJson);
        var userId = user.id;

        if(
            tables && 
            Object.hasOwn(tables,table) &&
            Object.hasOwn(tables[table],'config') && 
            Object.hasOwn(tables[table]['config'],userId)
        ){

            if(parameter){
                
                if(tables[table]['config'][userId] && Object.hasOwn(tables[table]['config'][userId],parameter)){
                    tables[table]['config'][userId][parameter] = null;
                }
            }
            else{
                tables[table]['config'][userId] = null;
            }

            var json = JSON.stringify(tables);
            localStorage.setItem('tables',json);

            return tables[table]['config'][userId];
        }
    }
    else{
        return null;
    }
}

// return regExp to check if /table/view/N
const viewRegExp = () => {

    //const regExp = new RegExp(`\/${table}\/view\/([0-9]+)`);
    const regExp = /\/([a-zA-Z-_]+)\/(view|fullview)\/([0-9]+)$/

    return regExp;
}

// check if we are on table/view/N or table/fullview/N
export const checkViewPath = (path = null) => {

    if(!path){
        path = window.location.pathname;
    }

    var check = false;

    const regExp = viewRegExp();
    if(regExp.test(path)){
        const matches = path.match(regExp);
        // matches[0] => /tickets/view/29
        // matches[1] => tickets (1st group)
        // matches[2] => view or fullview
        // matches[3] => 29 (2nd group)        
        if(matches){
            check = matches;
        }
    }

    return check;
}


// check if it is view or fullview
export const checkViewType = (path = null) => {
    
    var result = null;
    const matches = checkViewPath(path);
    
    if(matches && matches?.length > 2){
        result = matches[2];
    }

    return result;
}

// check if we are on table/view/N
// or table/fullview/N => to show in full page without menu and top bar
export const checkIfItemView = (path = null) => {

    var result = false;

    const matches = checkViewPath(path);

    if(matches){
       result = parseInt(matches[3]);        
    }

    return result;
}

// replace /table/view/NN => /table to check different things
export const replaceIfItemView = (path = null) => {

    if(checkIfItemView()){

        const regExp = viewRegExp();

        if(!path){
            path = window.location.pathname;
        }
        
        path = path.replace(regExp,"/$1");
    }

    return path;
}

// check if forgot password url
// /forgot
export const checkIfForgot = () => {

    var result = false;

    const regExp = /\/forgot\/?$/;

    if(regExp.test(window.location.pathname)){
        result = true;
    }

    return result;
}

// to check if view item details
export const checkViewItem = (router) => {

    var viewItemId = null;
    var viewType = null;

    const getViewPathValues = checkViewPath(router.pathname);        

    if(getViewPathValues && getViewPathValues[2]){
        viewType = getViewPathValues[2];
        viewItemId = getViewPathValues[3];
    }

    return { viewType, viewItemId };
}

// to get updated values
// with node.data you get the old ones
export const getNodeNewValues = (api,node,columns) => {

    var data = null;

    /*
    data = node?.data;
    console.log(data)
    const selectedNodes = api.getSelectedNodes();
    if(selectedNodes && selectedNodes.length > 0){
        
        const nodeNew = selectedNodes[0];
        const newData = nodeNew?.data;

        data = node?.data;

        var updated = false;        
        newData && Object?.keys(newData)?.forEach((column) => {                 
            
            if(newData[column] !== data[column]){                
                updated = true;
            }

            data[column] = newData[column];

        });

        // save flag on node
        node.updated = updated;
    }
    console.log(node.updated)
    */

    const cellsEditingAll = api.getEditingCells();
    const rowIndex = node?.rowIndex;

    // get the ones on the current row, just in case we use multi-editing
    const cellsEditing = cellsEditingAll?.filter(cellEditingAll => {
        return cellEditingAll?.rowIndex === rowIndex
    });
    
    // if no cells in edition mode, no error
    var updated = false;
    if(cellsEditing?.length > 0){ 

        data = node?.data;

        cellsEditing?.forEach((cellEditing) => {     

            data[cellEditing?.colId] = cellEditing?.newValue;
            
            if(cellEditing?.newValue !== cellEditing?.oldValue){
                updated = true;
            }

        });        
    }

    // if dropdown multiple or search, they are not editable, so if node not updated but we have dropdown, change to true
    // because if not and we only edit dropdown, does not detect change and does not save
    if(!updated){
        
        var dropdowns = false;
        
        var keys = Object?.keys(columns);
        if(keys && keys?.length > 0){
            keys?.map((key) => {

                if(dropdowns){
                    return;
                }

                if(columns[key]?.type === 'dropdown_search' || columns[key]?.type === 'dropdown_multiple'){
                    dropdowns = true;                    
                }
               
            });
        }

        if(dropdowns){
            updated = true;
        }
    }

    // save flag on node
    node.updated = updated;

    return data;                     
}